module.exports = __webpack_public_path__ + "img/Visa-color.e295110e.svg";